import axios from '../axios';
import { getApiPath } from '../utils';
const baseUrl = getApiPath();

export const create = (params) => {
  return axios({
    url: `${baseUrl}/ElsManagePageConfigService/create`,
    method: 'post',
    data: params
  });
};

export const findDetail = (templateCode) => {
  return axios({
    url: `${baseUrl}/ElsManagePageConfigService/findDetail/${templateCode}`,
    method: 'get'
  });
};

export const ElsManagePageConfigService = {
  create,
  findDetail
};
